<!--  CALLBACK  -->

<div class="callback">
	<!--  CALLBACK FORM  -->

	<div *ngIf="callback === null || callback_edit" class="container">
		<!--  HEADING  -->

		<div class="heading align-center">
			<h1>Create a callback request...</h1>
			<p>
				Check your number and let us know when
				<br class="visible-xxs visible-xs" />
				you would prefer us to call.
			</p>
		</div>

		<!--  END HEADING  -->

		<!--  FORM  -->

		<form
			class="form"
			name="configure_callback_form"
			[formGroup]="callback_form"
			(submit)="onSubmit()"
			(input)="onFormInput($event)"
			novalidate
		>
			<ui-text-control
				[form]="callback_form"
				[form_control]="callback_form.controls['first_name']"
				[type]="'text'"
				[label]="'Your First Name'"
				[placeholder]="'Enter your first name...'"
				[max_length]="50"
			></ui-text-control>
			<ui-text-control
				[form]="callback_form"
				[form_control]="callback_form.controls['last_name']"
				[type]="'text'"
				[label]="'Your Last Name'"
				[placeholder]="'Enter your last name...'"
				[max_length]="50"
			></ui-text-control>
			<ui-text-control
				[form]="callback_form"
				[form_control]="callback_form.controls['email']"
				[type]="'text'"
				[label]="'Your Email Address'"
				[placeholder]="'Enter your email address...'"
				[max_length]="255"
			></ui-text-control>
			<ui-text-control
				[form]="callback_form"
				[form_control]="callback_form.controls['tel_mob']"
				[type]="'text'"
				[label]="'Your Mobile Number'"
				[placeholder]="'Enter your mobile number...'"
				[max_length]="50"
			></ui-text-control>
			<ui-select-control
				[form]="callback_form"
				[form_control]="callback_form.controls['day_of_week']"
				[label]="'Preferred Day of Week'"
				[placeholder]="'Select preferred day of week...'"
				[options]="day_of_week_options"
				[empty_allowed]="false"
			></ui-select-control>
			<ui-select-control
				[form]="callback_form"
				[form_control]="callback_form.controls['time_of_day']"
				[label]="'Preferred Time of Day'"
				[placeholder]="'Select preferred time of day...'"
				[options]="time_of_day_options"
				[empty_allowed]="false"
			></ui-select-control>
			<ui-text-control
				[form]="callback_form"
				[form_control]="callback_form.controls['notes']"
				[type]="'textarea'"
				[label]="'Notes (Optional)'"
				[placeholder]="'Enter notes...'"
				[max_length]="1000"
				[autosize]="autosize_notes"
			></ui-text-control>
			<button class="hidden">Submit</button>
			<a
				class="button block-button positive-button"
				[class.loading]="loading"
				[attr.data-element-click]="'button__' + location + '__positive-button[Arrange Callback]'"
				(click)="onSubmit()"
			>
				<span class="loading-spinner"></span>
				<span *ngIf="!loading">Arrange Callback</span>
			</a>
		</form>

		<!--  END FORM  -->
	</div>

	<!--  END CALLBACK FORM  -->

	<!--  CALLBACK DETAILS  -->

	<div *ngIf="callback !== null && callback_edit === false" class="container callback-details">
		<!--  HEADING  -->

		<div class="heading align-center">
			<h1>Your callback is arranged</h1>
			<p>One of our specialist sales staff will be in touch shortly.</p>
		</div>

		<!--  END HEADING  -->

		<!--  DETAILS  -->

		<div class="row">
			<div class="col-xxs-30">
				<ul class="key-value-list striped alt-style">
					<li>
						<div class="key">First Name</div>
						<div class="value">{{ customer.first_name }}</div>
					</li>
					<li>
						<div class="key">Last Name</div>
						<div class="value">{{ customer.last_name }}</div>
					</li>
					<li>
						<div class="key">Email Address</div>
						<div class="value">{{ customer.email }}</div>
					</li>
					<li>
						<div class="key">Mobile Number</div>
						<div class="value">{{ customer.tel_mob }}</div>
					</li>
					<li>
						<div class="key">Preferred Day of week</div>
						<div class="value capitalise">{{ callback?.day_of_week }}</div>
					</li>
					<li>
						<div class="key">Preferred Time of Day</div>
						<div class="value capitalise">{{ callback?.time_of_day }}</div>
					</li>
					<li>
						<div class="key">Notes</div>
						<div class="value">
							<a
								*ngIf="callback?.notes === null || callback?.notes === ''"
								class="text-hl"
								(click)="onAddNotes()"
							>
								<strong>Add notes</strong>
							</a>
							<span *ngIf="callback?.notes !== null && callback?.notes !== ''">
								{{ callback?.notes }}
							</span>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<!--  END DETAILS  -->

		<a
			class="button block-button"
			[attr.data-element-click]="'button__' + location + '__primary-button[Edit Callback]'"
			(click)="onCallbackSubmit()"
		>
			<span>Edit Callback</span>
		</a>
	</div>

	<!--  END CALLBACK DETAILS  -->

	<div class="footer-logos">
		<ui-trust-logos [location]="location"></ui-trust-logos>
	</div>
</div>

<!--  END CALLBACK  -->
